/**
 * A helper for constructing media queries using Sail's design tokens.
 *
 * @see https://sail.stripe.me/apis/media
 */ export const media = {
    query (value) {
        return `@media ${value.replace(/@media /g, '')}`;
    },
    up (value) {
        return media.query(`(min-width: ${value})`);
    },
    down (value) {
        return media.query(`(max-width: calc(${value} - 0.1px))`);
    },
    between (min, max) {
        return media.query(`(${media.up(min)} and ${media.down(max)})`);
    }
};

//# sourceMappingURL=media.js.map